import { JsonNode } from "../../../../utils/types"
import { Editor, Path } from "slate"
import { isPathInRectangle } from "./mergeCells"

export const getSelectedCells = (editor: Editor, tablePath: Path) => {
  return Editor.nodes(editor, {
    match: (node: JsonNode, path) =>
      node.type === 'th' || (node.type === 'td' && isPathInRectangle(editor, path, tablePath))
  })
}